<div [formGroup]='parentGroup'>

  @if (!isPhone) {
    <bolt-textfield [label]='label' [type]="type || 'text'" [iconname]="iconname" [prefixsymbol]='prefixsymbol' [suffix]='suffix'
      [attr.aria-label]="ariaLabel" [maxlength]="maxlength" [minlength]="minlength" [attr.min]="min" [attr.max]="max" (focus)="onFocus()"
      (blur)="onBlur()" (change)="onChange()" ngDefaultControl [id]="inputFormControl" [formControlName]='inputFormControl'
      [required]="required"  [optionaltext]="optionaltext"
      [attr.error]='nwInputErrorService.validateBoltTextfield(parentGroup,inputFormControl)'>
      @if (helpTextAttributes) {
        <bolt-contextual-help
          slot="help">
          <p>{{helpTextAttributes}}</p>
        </bolt-contextual-help>
      }</bolt-textfield>
    }

    @if (isPhone) {
      <bolt-textfield  [label]='label' isPhoneNumberMask [type]="type || 'text'" [iconname]="iconname" [prefixsymbol]='prefixsymbol' [suffix]='suffix'
        [attr.aria-label]="ariaLabel" [maxlength]="maxlength" [minlength]="minlength" [attr.min]="min" [attr.max]="max" (focus)="onFocus()"
        (blur)="onBlur()" (change)="onChange()" ngDefaultControl [id]="inputFormControl" [formControlName]='inputFormControl'
        [required]="required" [optionaltext]="optionaltext" [helptext]='helpTextAttributes'
        [attr.error]='nwInputErrorService.validateBoltTextfield(parentGroup,inputFormControl)'>@if (helpTextAttributes) {
        <bolt-contextual-help
          slot="help">
          <p>{{helpTextAttributes}}</p>
        </bolt-contextual-help>
      }</bolt-textfield>
    }

  </div>
